import { render, staticRenderFns } from "./ASC_BasicSummary.vue?vue&type=template&id=75cff1e0&scoped=true&"
import script from "./ASC_BasicSummary.vue?vue&type=script&lang=js&"
export * from "./ASC_BasicSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cff1e0",
  null
  
)

export default component.exports